import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../../config';
import { useNavigate } from 'react-router-dom';
import useFetchUsers from '../../hooks/fetchUsers';
import { Select, Form, Pagination, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { EditTwoTone } from '@ant-design/icons';
import { dateConverter } from '../../utils/utcDateConversion';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import AddDenomination from './AddDenomination';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import NoRecordFound from '../../components/common/NoRecordFound';

function Denominations() {
  const { t } = useTranslation(['common']);
  let { Search } = Input;
  let navigate = useNavigate();
  let users;
  let searchedUser;
  let searchedMerchant;
  const [form] = Form.useForm();
  const [editbtn, setEditBtn] = useState('none');
  const [search, setSearch] = useState('');
  const [current, setCurrent] = useState(1);
  const [fetchDenominations, setFetchDenominations] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [renderList, setRenderList] = useState();
  const [commonData, setCommonData] = useState([]);
  const [orgdata, setOrgData] = useState();
  const [pageObj, setPageObj] = useState({});
  const [tableShow, setTableShow] = useState(true);
  const [clearSearch, setClearSearch] = useState(false);
  // const userResp = useFetchUsers();
  const token = getTokenfromUserObj();
  const user = JSON.parse(localStorage.getItem('user'));
  const handleClearClick = () => {
    console.log('Clear search called');
    setOrgData();
    form.resetFields();
    console.log(document.getElementById('search').value);
    document.getElementById('search').value = null;
    document.getElementById('search').innerHTML = null;
    setClearSearch(true);
  };
  const orgResp = useFetchOrganizations();
  console.log(orgResp);
  let orgObj = orgResp.response ? orgResp.response.data : [];
  useEffect(() => {
    const fetchDataByOrg = async () => {
      console.log('fetch data by org');
      let eventAPI;
      let dataObj = {
        limit: 10,
        offset: 0,
      };
      if (!pageObj.limit) setPageObj(dataObj);

      if (user.userType === 'A') eventAPI = `${app.URL}/denomination/viewbyorg`;
      const prayerResp = await axios.post(eventAPI, { organizationId: orgdata }, { headers: { auth: token } });
      console.log(prayerResp);
      console.log(prayerResp.data.data);
      console.log(prayerResp.data.data.count);
      let convertedObj;
      prayerResp.data ? (convertedObj = dateConverter(prayerResp.data.data, 'startDate')) : ' ';
      convertedObj = dateConverter(convertedObj, 'endDate');
      prayerResp.data ? setFetchDenominations(convertedObj) : [];
      prayerResp.data ? setCommonData(convertedObj) : [];
      prayerResp.data ? setPagesCount(prayerResp.data.data.count) : 0;
      prayerResp.data ? setRenderList(convertedObj) : [];
    };
    fetchDataByOrg();
  }, [orgdata, pageObj]);
  useEffect(() => {
    const denominationList = async () => {
      if (user.userType === 'A') setEditBtn('block');
      const limit = 1000;
      const offset = 0;
      let denominationRes;
      if (user.userType === 'A' && window.location.pathname === '/denominations/view') denominationRes = await axios.get(`${app.URL}/denomination/view`, { headers: { auth: token } });
      else if (user.userType === 'O' && window.location.pathname === '/denomination/view') denominationRes = await axios.post(`${app.URL}/denomination/viewbyorg`, { organizationId: user.organizationId }, { headers: { auth: token } });
      denominationRes.data ? setFetchDenominations(denominationRes.data.data) : ' ';
      denominationRes.data ? setPagesCount(denominationRes.data.data.length) : ' ';
      denominationRes.data ? setRenderList(denominationRes.data.data.slice(0, 50)) : ' ';
      setClearSearch(false);
    };
    denominationList();
  }, [clearSearch]);
  console.log(fetchDenominations);
  const onSearch = async (value) => {
    console.log(value);
    try {
      let result;
      if (user.userType === 'A' && window.location.pathname === '/denominations/view') result = await axios.get(`${app.URL}/denomination/search/${value}`, { headers: { auth: token } });
      else if (user.userType === 'O' && window.location.pathname === '/denomination/view') result = await axios.get(`${app.URL}/denomination/searchbyorg/${value}/${user.organizationId}`, { headers: { auth: token } });
      console.log(result);
      searchedMerchant = result.data.data;
      setRenderList(searchedMerchant);
      setPagesCount(searchedMerchant.length);
      // result.data.data ? form.setFieldsValue({ ['search']: "" }) : '';

    } catch (e) {
      console.log('Error');
      console.log(e);
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }
  };
  const onChange = async (page, pageSize) => {
    console.log(page);
    setCurrent(page);
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    setRenderList(fetchDenominations.slice(reqObj.offset, reqObj.offset + limit));
    console.log(renderList);
  };

  const handleSearchChange = (e) => {
    console.log(e.target.value);
    if (!e.target.value) {
      setRenderList(fetchDenominations.slice(0, 50));
      setPagesCount(fetchDenominations.length);
      setTableShow(true);
    }
    setSearch(e.target.value);
  };
  const selectOrgId = (e) => {
    console.log('Select org Id');
    setOrgData(e);
  };
  const onFinish = (values) => {
    console.log('Success:', values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const editUser = (e) => {
    console.log(e);
    localStorage.setItem('denominationId', JSON.stringify(e.denominationId));
    if (user.userType === 'A') navigate('/denominations/edit', { replace: true });
    else if (user.userType === 'O') navigate('/denomination/edit', { replace: true });
  };
  const addDenom = () => {
    if (user.userType === 'A') navigate('/denominations/add', { replace: true });
    else if (user.userType === 'O') navigate('/denomination/add', { replace: true });
  };
  console.log(renderList);
  function goBack() {
    if (user.userType === 'A') navigate('/denominations/view', { replace: true });
    else if (user.userType === 'O') navigate('/denomination/view', { replace: true });
  }
  window.addEventListener('popstate', goBack);
  console.log(renderList);
  return (
    <div className='ml-3 col-lg-12 col-md-12 col-sm-12 '>
      <div className='row'>
        <div className='col-lg-8 col-md-8 col-sm-12 '>
          <div class='mt-4 fs-3 fw-bold'> {t('Denomination Management')} </div>
        </div>

        {user.userType === 'A' ? (
          <Form
            name='basic'
            form={form}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <div className='row text-left mt-4 mt-2'>
              <div className='col-lg-3 eventselect'>
                <Form.Item
                  form={form}
                  colon={false}
                  name='organizationId'
                  rules={[
                    {
                      required: false,
                      message: 'Select Organization',
                    },
                  ]}
                >
                  <Select
                    className='custom-select-dropdown'
                    listHeight={250}
                    listItemHeight={500}
                    onChange={selectOrgId}
                    style={{
                      display: 'inline-block ',
                    }}
                    placeholder='Select Organization'
                  >
                    {orgObj.map((orgs) => {
                      return (
                        <Option className='select-option' key={orgs.organizationId} value={orgs.organizationId}>
                          {orgs.organizationName}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </div>
              <div className='col-lg-2'>
                <button class='btn btn-primary button'
                  onClick={handleClearClick}
                //
                >
                  Clear
                </button>
              </div>
              <div className='col-lg-3'>
                <Form.Item
                name="search">
                  <Search
                    id='search'
                    className='event-search'
                    placeholder='Search by Title'
                    onSearch={onSearch}
                    onChange={handleSearchChange}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();  // Prevents the form from submitting on Enter key press
                        onSearch(e.target.value);  // Calls the search function directly
                      }
                    }}
                    style={{
                      width: 300,
                      height: 50,
                    }}
                  />
                </Form.Item>
              </div>
              <div className='col-lg-3 offset-lg-1 text-right col-md-4 col-sm-12'>
                <button class='btn btn-primary button' onClick={addDenom}>
                  Add Denomination
                </button>
              </div>
            </div>
          </Form>
        ) : (
          ' '
        )}
        {user.userType === 'O' ? (
          <Form
            name='basic'
            form={form}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <div className='row text-right mt-4 mt-2'>
              <div className='col-lg-4 eventSelect'></div>
              <div className='col-lg-4'>
                <Form.Item>
                  <Search
                    id='search'
                    className='event-search'
                    placeholder='Search by Title'
                    onSearch={onSearch}
                    onChange={handleSearchChange}
                    style={{
                      width: 300,
                      height: 50,
                    }}
                  />
                </Form.Item>
              </div>
              <div className='col-lg-3 offset-lg-1 text-center col-md-4 col-sm-12'>
                <button class='btn btn-primary button' onClick={addDenom}>
                  Add Denomination
                </button>
              </div>
            </div>
          </Form>
        ) : (
          ' '
        )}
      </div>
      <div className='col-lg-12 col-md-12 col-sm-12 '>
        <div class=' styled-table '>
          <table class='table text-black'>
            <thead class='thead-light'>
              <tr>
                {user.userType === 'A' ? <th>{t('Organization')}</th> : ''}
                <th>{t('Cause')}</th>
                <th>{t('Denomination')}</th>
                <th>{t('Status')}</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {renderList
                ? renderList.map((output) => (
                    <tr
                      className='row-hover'
                      onClick={() => {
                        editUser(output);
                      }}
                    >
                      {user.userType === 'A' ? <td style={{ width: '360px' }}>{output.organization ? output.organization : output.organizationName}</td> : ' '}
                      <td style={{ width: '360px' }}>
                        <span style={{ marginLeft: '10px' }}>{output.cause ? output.cause : 'null'}</span>
                      </td>
                      <td style={{ width: '360px' }}>
                        <span style={{ marginLeft: '10px' }}>{output.amount ? output.amount : 'null'}</span>
                      </td>
                      <td style={{ width: '260px' }}>{output.isActive === 1 ? 'Active' : 'Inactive'}</td>
                      <td>
                        <EditTwoTone
                          displayName='edit'
                          twoToneColor='blue'
                          style={{ fontSize: '20px' }}
                          onClick={() => {
                            editUser(output);
                          }}
                        />
                        {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                         {t('Edit')}
                       </button> */}
                      </td>
                    </tr>
                  ))
                : ' '}
            </tbody>
          </table>
          {renderList && renderList.length == 0 ? <NoRecordFound /> : ' '}
        </div>
      </div>
      <Pagination style={{ marginTop: '10px' }} onChange={onChange} defaultCurrent={current} pageSize={50} total={pagesCount} />
    </div>
    //     </div>
    //   </div>
    // </div>
  );
}

export default Denominations;
